export default __webpack_public_path__ + "static/media/9-color.13b897bc.svg";